/**
 * Check-In Process - Automated Messages Settings
 * Configure messages sent during the check-in flow
 */

import { createFileRoute, useParams } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { SettingsPageHeader } from '@/components/ui'
import { BusinessSetupPageShell } from './business-setup/components/business-setup-page-shell'
import { CheckInProcessTimeline } from './automated-messages/components/check-in-process-timeline'
import { formatDocumentTitle } from '@/lib/document-title'

export const Route = createFileRoute(
  '/_auth/$orgId/settings/automated-messages/check-in-process',
)({
  component: CheckInProcessPage,
})

function CheckInProcessPage() {
  const { orgId } = useParams({
    from: '/_auth/$orgId/settings/automated-messages/check-in-process',
  })

  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Check-In Process', 'Automated Messages')}</title>
      </Helmet>

      <BusinessSetupPageShell orgId={orgId} activePath="check-in-process">
        <SettingsPageHeader
          title="Check-In Process"
          description="Configure which automated messages are sent for the check-in process."
        />

        <div className="max-w-3xl">
          <CheckInProcessTimeline />
        </div>
      </BusinessSetupPageShell>
    </>
  )
}
